import { SUPER_ROLES } from '../config/permissions';

/**
 * canDo(auth, permission)
 *
 * Returns true if the logged-in user is allowed to perform the action.
 *
 * Rules:
 *  1. owner / solution roles → always allowed (no permission check needed)
 *  2. Otherwise → user must have the exact permission string in auth.permissions[]
 *
 * @param {object} auth        - The auth object from useAuth()
 * @param {string} permission  - A permission key e.g. 'patients.view'
 * @returns {boolean}
 */
export function canDo(auth, permission) {
  if (!auth) return false;
  const roles = auth.roles || [];
  if (roles.some(r => SUPER_ROLES.includes(r))) return true;
  return (auth.permissions || []).includes(permission);
}

/**
 * isSuper(auth)
 * Quick check — is this user an owner or solution role?
 */
export function isSuper(auth) {
  if (!auth) return false;
  return (auth.roles || []).some(r => SUPER_ROLES.includes(r));
}
